import { type Button, useMediaQuery } from "@mui/material";
import type { Theme } from "@mui/material/styles";
import { type ReactElement, useEffect, useId } from "react";
import { useResponsiveButtons } from "./context";

interface IResponsiveButtonRegisterProps {
  children: ReactElement<typeof Button>;
  position: number;
}

export const ResponsiveButtonRegister = ({ children, position }: IResponsiveButtonRegisterProps) => {
  const elementId = useId();
  const { registerButton, unregisterButton, breakpoint } = useResponsiveButtons();
  const breakpointReached = useMediaQuery((theme: Theme) => theme.breakpoints.up(breakpoint));

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => registerButton(elementId, children, position), [children]);
  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    return () => {
      unregisterButton(elementId);
    };
  }, []);

  return <>{!breakpointReached ? null : children}</>;
};
